export enum PlansPageSortOptions {
  most_popular = 'most_popular',
  price_low_to_high = 'price_low_to_high',
  price_high_to_low = 'price_high_to_low',
  fastest_speed = 'fastest_speed',
}
